import { useEffect, useState } from 'react';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import swal from "sweetalert";
import { getGstdetail, SaveGstdetail } from '../../Services/Service';
const GstDetail = () => {
  const [loading, setLoading] = useState(false);

  const [GstformData, setGstFormData] = useState({
    GSTNumber: '',
    ContactNo: '',
    Name: '',
    Email: '',
    ExtraGuestCharge: '',
    State: '',
    Designation: '',
    PinCode: '',
    Address: ''
  });

  useEffect(() => {
    const getGstDetals = async () => {
      setLoading(true);
      try {
        const result = await getGstdetail();
        if (result && result.length > 0) {
          setGstFormData(result[0]);
        }
      }
      catch (error) {
        console.log("error getting gst detail", error);
      }finally{
        setLoading(false);
      }
    }
    getGstDetals();
  }, []);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const result = await SaveGstdetail(GstformData);
      console.log("GST Save Response:", result);
      
      swal("GST Details Saved Successfully", {
      icon: "success",
      buttons: {
        confirm: {
          text: "OK",
          className: "btn btn-success",
        },
      },
    });
    } catch (error) {
      console.error("Failed to save GST details", error);
      alert("Error saving GST details.");
    }finally{
      setLoading(false);
    }
  };



  return (
    <>
    {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
        </div>
      )}
      
      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">GST Details</div>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="input-block mb-3">
                              <label className="col-form-label">GST Number</label>
                              <input type="number" className="form-control" placeholder="Enter GST Number" value={GstformData.GSTNumber} onChange={(e) => setGstFormData({ ...GstformData, GSTNumber: e.target.value })} required />
                            </div>
                            <div className="input-block mb-3">
                              <label className="col-form-label">Contact No</label>
                              <input type="number" className="form-control" placeholder="Enter Contact No" value={GstformData.ContactNo} onChange={(e) => setGstFormData({ ...GstformData, ContactNo: e.target.value })} />
                            </div>
                            <div className="input-block mb-3">
                              <label className="col-form-label">Name</label>
                              <input type="text" className="form-control" placeholder="Enter Name" value={GstformData.Name} onChange={(e) => setGstFormData({ ...GstformData, Name: e.target.value })} />
                            </div>
                            <div className="input-block mb-3">
                              <label className="col-form-label">Email</label>
                              <input type="email" className="form-control" placeholder="Enter Email" value={GstformData.Email} onChange={(e) => setGstFormData({ ...GstformData, Email: e.target.value })} />
                            </div>
                            <div className="input-block d-flex mb-3">
                              <label className="col-form-label d-block me-2">Add extra guest charges to declared rate</label>
                              <div className="form-check">
                                <input type="checkbox" className="form-check-input mt-0" checked={GstformData.ExtraGuestCharge === true || GstformData.ExtraGuestCharge === "true"}
                                  onChange={(e) =>
                                    setGstFormData({
                                      ...GstformData,
                                      ExtraGuestCharge: e.target.checked
                                    })
                                  } />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block mb-3">
                              <label className="col-form-label">State</label>
                              <input type="text" className="form-control" placeholder="Enter State" value={GstformData.State} onChange={(e) => setGstFormData({ ...GstformData, State: e.target.value })} />
                            </div>
                            <div className="input-block mb-3">
                              <label className="col-form-label">Designation</label>
                              <input type="text" className="form-control" placeholder="Enter Designation" value={GstformData.Designation} onChange={(e) => setGstFormData({ ...GstformData, Designation: e.target.value })} />
                            </div>
                            <div className="input-block mb-3">
                              <label className="col-form-label">Pin Code</label>
                              <input type="number" className="form-control" placeholder="Enter Pin Code" value={GstformData.PinCode} onChange={(e) => setGstFormData({ ...GstformData, PinCode: e.target.value })} />
                            </div>
                            <div className="input-block mb-3">
                              <label className="col-form-label">Address</label>
                              <textarea rows="2" className="form-control" placeholder="Enter Address" value={GstformData.Address} onChange={(e) => setGstFormData({ ...GstformData, Address: e.target.value })}></textarea>
                            </div>
                          </div>
                        </div>
                        <div className="card-action text-end">
                          <button type="submit" className="btn btn-black">Submit</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
        </div>
     </div>
    </>
  );
};

export default GstDetail;